import { render, staticRenderFns } from "./MatterPlaintiffList.vue?vue&type=template&id=491bdfaf&"
import script from "./MatterPlaintiffList.vue?vue&type=script&lang=js&"
export * from "./MatterPlaintiffList.vue?vue&type=script&lang=js&"
import style0 from "./MatterPlaintiffList.vue?vue&type=style&index=0&id=491bdfaf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports